// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 738 ? "1484b9de" : chunkId) + "." + {"16":"7bf8a2627633b616","738":"bb99a77b1102a3a1","743":"0706e2355ce542e8"}[chunkId] + ".js";
};